import { loadScript } from './loadScript';
import { initMixpanel } from './mixpanel';

// ==== Mouseflow ====
export async function loadMouseflow() {
  await loadScript(`//cdn.mouseflow.com/projects/c13bcfe7-bdc3-4737-b9a3-992157baf90f.js`, { defer: true });
}

// ==== New Relic Browser ====
export async function loadNewRelicBrowser() {
  await loadScript('/newrelic.js');
}

// ==== Mixpanel ====
export async function loadMixpanel() {
  initMixpanel();
}

// ==== Twillio segment? ====
export async function loadAnalytics() {
  var analytics = (window as any).analytics || [];
  if (!analytics.initialize)
    if (analytics.invoked) window.console && console.error && console.error('Segment snippet included twice.');
    else {
      analytics.invoked = !0;
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on',
      ];
      analytics.factory = function (t: any) {
        return function () {
          var e = Array.prototype.slice.call(arguments);
          e.unshift(t);
          analytics.push(e);
          return analytics;
        };
      };
      for (var t = 0; t < analytics.methods.length; t++) {
        var e = analytics.methods[t];
        analytics[e] = analytics.factory(e);
      }
      analytics.load = function (t: any, e: any) {
        var n = document.createElement('script');
        n.type = 'text/javascript';
        n.async = !0;
        n.src = 'https://cdn.segment.com/analytics.js/v1/' + t + '/analytics.min.js';
        var a = document.getElementsByTagName('script')[0];
        a.parentNode?.insertBefore(n, a);
        analytics._loadOptions = e;
      };
      analytics.SNIPPET_VERSION = '4.1.0';
      analytics.load('PCyUCu5Vap0LjbyCMdh1FwbIyNBB2ngw');
    }
}
